import ShippingAddressSwitcher from './shippingAddressSwitcher';

export default ShippingAddressSwitcher;